import { Injectable } from '@angular/core';
import { SequentialGuardCombinator } from './sequential-guard-combinator';
import { LoginGuard } from './login.guard';
import { EulaGuard } from './eula.guard';
import { DeletedCaseGuard } from './deleted-case.guard';
import { UserProfileGuard } from './user-profile.guard';
import { DeletedAccountGuard } from './deleted-account.guard';
import { MfaGuard } from './mfa.guard';

@Injectable({
	providedIn: 'root'
})
export class PrerequisitesGuard extends SequentialGuardCombinator {

	constructor(loginGuard: LoginGuard, mfaGuard: MfaGuard, eulaGuard: EulaGuard, deletedCaseGuard: DeletedCaseGuard, userProfileGuard: UserProfileGuard, deletedAccountGuard: DeletedAccountGuard) {
		super(loginGuard, mfaGuard, eulaGuard, deletedCaseGuard, userProfileGuard, deletedAccountGuard);
	}
}

@Injectable({
	providedIn: 'root'
})
export class PrerequisitesWithoutDeleteCheckGuard extends SequentialGuardCombinator {

	constructor(loginGuard: LoginGuard, mfaGuard: MfaGuard, eulaGuard: EulaGuard, userProfileGuard: UserProfileGuard) {
		super(loginGuard, mfaGuard, eulaGuard, userProfileGuard);
	}
}
